import { Link } from "react-router-dom";
import { EmptyState } from "../../ui";
import { useNextT } from "../../i18n";
import { useDefaultLandingPage } from "../../bridges/session";
import { ROUTES_PATH } from "../../shell/nav";
import { ManagerHelp } from "./ManagerHelp";
import s from "./Notices.module.scss";

/**
 * Board 94 (team) and 71 E (routes): the page for a link the person has no right to. No role words, and for routes
 * one message for "missing" and "not allowed" so a link cannot reveal that a route exists.
 */
export const NotForYou = ({ area }: { area: "team" | "routes" | "generic" }) => {
  const { t } = useNextT();
  const home = useDefaultLandingPage();
  const to = area === "routes" ? ROUTES_PATH : home;
  return (
    <>
      <EmptyState title={t(`access.not_for_you.${area}.title`)} body={t(`access.not_for_you.${area}.body`)}
        action={<Link to={to} className={`${s.link} ${s.primary}`}>{t(`access.not_for_you.${area}.action`)}</Link>} />
      <ManagerHelp />
    </>
  );
};

/**
 * Owner 2026-10-30 (decision 4): an address the person has no right to is a plain "Page not found", in the frame, in the 404's
 * own words (board 302) — never a "no access" page and never a guess about where the link came from.
 */
export const InFrameNotFound = () => {
  const { t } = useNextT();
  const home = useDefaultLandingPage();
  return (
    <EmptyState title={t("public.notfound.title")} body={t("public.notfound.body")}
      action={<Link to={home} className={`${s.link} ${s.primary}`}>{t("public.notfound.home")}</Link>} />
  );
};
